<template>
  <v-card color="basil">
    <v-tabs
      v-model="tab"
      background-color="transparent"
      color="basil"
      grow
    >
      <v-tab
        v-for="item in items"
        :key="item"
        @click="Reload()"
      >
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="it in items"
        :key="it"
      >
        <v-card
          color="basil"
          flat
        >
          <v-card-text>
            <VariableCost
              v-if="it == 'Travel Cost'"
              :datacost="item"
            ></VariableCost>
            <HotelCost
              v-if="it == 'Hotel' && statustab"
              :datacost="item"
            ></HotelCost>
            <RestaurantCost
              v-if="it == 'Restaurant'"
              :datacost="item"
            ></RestaurantCost>
            <ActivityCost
              v-if="it == 'Activity'"
              :datacost="item"
            ></ActivityCost>
            <TranspotCost
              v-if="it == 'Transport'"
              :datacost="item"
            ></TranspotCost>
            <EntranceCost
              v-if="it == 'Entrance Fee'"
              :datacost="item"
            ></EntranceCost>
            <OthersCost
              v-if="it == 'Others'"
              :datacost="item"
            ></OthersCost>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <v-card-actions>
      <v-simple-table>
        <thead>
          <tr class="font-weight-bold text-h6  ">
            <td>
              <span class=" text-h6 "> Total Perpax Adult </span>
            </td>
            <td>
              <span class=" text-h6 ">: Rp. {{ Number(item.total_perpax_adult).toLocaleString() }}</span>
            </td>
          </tr>
          <tr
            v-if="item.total_cnb > 0"
            class="font-weight-bold text-h6  "
          >
            <td>
              <span class="  text-h6 ">Total Perpax CNB </span>
            </td>
            <td>
              <span class=" text-h6 ">: Rp. {{ Number(item.total_perpax_cnb).toLocaleString() }}</span>
            </td>
          </tr>
          <tr
            v-if="item.total_cwb > 0"
            class="font-weight-bold text-h6  "
          >
            <td>
              <span class=" text-h6 ">Total Perpax CWB </span>
            </td>
            <td>
              <span class=" text-h6 ">: Rp. {{ Number(item.total_perpax_cwb).toLocaleString() }}</span>
            </td>
          </tr>
          <tr class="font-weight-bold text-h6 bg-gradient-primary ">
            <td>
              <span class="  text-h6 ">Grand Total </span>
            </td>
            <td>
              <span class=" text-h6 ">: Rp. {{ Number(item.grandtotal).toLocaleString() }}</span>
            </td>
          </tr>
        </thead>
      </v-simple-table>
    </v-card-actions>
  </v-card>
</template>
<script>
import VariableCost from '@/layouts/components/service-order/variable-cost.vue'
import HotelCost from '../../layouts/components/service-order/hotel-cost.vue'
import ActivityCost from '../../layouts/components/service-order/activity-cost.vue'
import TranspotCost from '../../layouts/components/service-order/transpot-cost.vue'
import EntranceCost from '../../layouts/components/service-order/entrance-cost.vue'
import RestaurantCost from '../../layouts/components/service-order/restaurant.cost.vue'

export default {
  components: {
    VariableCost,
    HotelCost,
    ActivityCost,
    TranspotCost,
    EntranceCost,
    RestaurantCost,
  },
  props: ['item'],
  data() {
    return {
      tab: null,
      statustab: true,
      items: [
        'Travel Cost',
        'Restaurant',
        'Activity',
        'Transport',
        'Entrance Fee',
        'Hotel',
      ],
      text: 'Masih dalam proses penarikan data',
    }
  },
  methods: {
    Reload() {
      this.statustab = false
      this.statustab = true
      console.log(this.item)
    },
  },
}
</script>
